var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-fast-loan-audit',{ref:"table",staticClass:"pt-fast-loan-audit__withData",attrs:{"allCitys":_vm.allCitys},on:{"flashBorrowCompleted":_vm.flashBorrowCompleted,"flashBorrowExport":_vm.flashBorrowExport}})}
var staticRenderFns = []

export { render, staticRenderFns }